import React from 'react';
import { appConfig } from '../config/app';

const SocialMediaCard = () => {
  const socialPlatforms = [
    { key: 'tiktok', icon: 'bi bi-tiktok', color: '#ffffff' },
    { key: 'facebook', icon: 'bi bi-facebook', color: '#1877f2' },
    { key: 'instagram', icon: 'bi bi-instagram', color: '#e4405f' },
    { key: 'youtube', icon: 'bi bi-youtube', color: '#ff0000' },
    { key: 'twitter', icon: 'bi bi-twitter-x', color: '#ffffff' },
    { key: 'linkedin', icon: 'bi bi-linkedin', color: '#0a66c2' },
    { key: 'reddit', icon: 'bi bi-reddit', color: '#ff4500' }
  ];

  return (
    <div className="social-media-content">
      <div className="text-center mb-3">
        <h4 className="social-title mb-2">Follow Us</h4>
        <p className="social-subtitle text-muted">
          We repost user videos when you tag us
        </p>
      </div>

      <div className="social-platforms-row">
        {socialPlatforms.map((platform) => {
          const platformData = appConfig.social.platforms[platform.key];
          if (!platformData) return null;

          return (
            <a
              key={platform.key}
              href={platformData.url}
              target="_blank"
              rel="noopener noreferrer"
              className="social-platform-link"
            >
              <div 
                className="social-platform-item-inline"
                style={{ '--platform-color': platform.color }}
              >
                <i className={platform.icon}></i>
              </div>
            </a>
          );
        })}
      </div>


    </div>
  );
};

export default SocialMediaCard;


